import {
  BankVerificationResponse,
  getBankVerificationWarning,
} from './bank-verification';

export type BankCheckInput = { accountNumber: string; sortCode: string };
export type BankCheckOutcome = {
  status: 'Verified' | 'Invalid' | 'Error';
  message: string;
};

export const normalizeBankDetails = (bank: BankCheckInput): BankCheckInput => ({
  accountNumber: bank.accountNumber.replace(/\s/g, ''),
  sortCode: bank.sortCode.replace(/[\s-]/g, ''),
});

export const getBatchBankResult = (
  input: BankCheckInput,
  items: BankVerificationResponse[],
): BankCheckOutcome => {
  const error = items.find((item) => item.Error);
  if (error)
    return { status: 'Error', message: getBankVerificationWarning(error)! };
  // Match original inputs, not response position or corrected account details.
  const result = items.find(
    (item) =>
      item.OriginalAccountNumber === input.accountNumber &&
      item.OriginalSortCode === input.sortCode,
  );
  if (!result)
    return { status: 'Error', message: 'No matching result returned.' };
  const warning = getBankVerificationWarning(result);
  return {
    status:
      warning === null
        ? 'Verified'
        : result.IsCorrect === false
          ? 'Invalid'
          : 'Error',
    message:
      warning ??
      'Sort code and account number are valid. Account holder name is not checked.',
  };
};
